// extracted by mini-css-extract-plugin
export default {"div":"PantallaEnDesarrollo_div__AFE9I","titulo":"PantallaEnDesarrollo_titulo__EbBbB","imagen":"PantallaEnDesarrollo_imagen__jSzfl"};